import { Box } from '@mui/material';
import { type FC } from 'react';

export const Scenario: FC = () => {
  return (
    <Box
      width="100%"
      height={250}
      alt="Escenario de compuerta"
      component="img"
      src={`/static/gate-scenario.svg`}
      sx={{
        objectFit: 'cover',
        objectPosition: '0 50%',
        border: 2,
        borderRadius: 1,
      }}
    />
  );
};
